import { render, staticRenderFns } from "./BmPedidosProduccion.vue?vue&type=template&id=d29ec2d4&"
import script from "./BmPedidosProduccion.vue?vue&type=script&lang=js&"
export * from "./BmPedidosProduccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports